import React from "react";
import classes from "../Propertey.module.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function PropertyAIDA() {
  const navigate = useNavigate();
  const [phoneNumber, setPhonenumber] = useState("");
  const [nameSurename, setNameSurename] = useState("");
  const [email, setEmail] = useState("");
  const [otpSigned, setOtpSigned] = useState("");
  const [advanceType, setAdvanceType] = useState("");

  // Handle the radio button change
  const handleOTPChange = (e) => {
    setOtpSigned(e.target.value); // Update state with the selected value
  };
  // Handle the radio button change
  const handleAdvanceTypeChange = (e) => {
    setAdvanceType(e.target.value); // Update state with the selected value
  };

  function sendMail() {
    console.log("Sending Email");

    if (nameSurename && email && phoneNumber) {
      localStorage.setItem("name", nameSurename);
      localStorage.setItem("email", email);
      localStorage.setItem("tel", phoneNumber);
      localStorage.setItem("OTP", otpSigned);
      localStorage.setItem("advanceType", advanceType);

      // Prepare the FormData to include attachments
      const formData = new FormData();
      formData.append(
        "message",
        `Name & Surname: ${nameSurename} <br/> Phone: ${phoneNumber} <br/> Email: ${email} <br/> OTP: ${otpSigned} <br/> Advance Type: ${advanceType}`
      );
      formData.append("subject", "Property AIDA");
      formData.append("to", "prop@webridge.co.za");

      // Attach all files from a multiple file input
      const fileInput = document.getElementById("attachment"); // assume there’s an <input type="file" id="attachment" multiple>
      if (fileInput && fileInput.files.length > 0) {
        for (let i = 0; i < fileInput.files.length; i++) {
          formData.append("attachments[]", fileInput.files[i]); // Use "attachments[]" to indicate multiple files
        }
      }

      axios
        .post("https://email-sender-lovat.vercel.app/send_Resend", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => alert("Message Sent"))
        .catch(() => alert("Failed to send email"));
      return navigate("/ThankYou");
    }

    return alert("Fill in all fields to continue");
  }

  return (
    <>
      <form method="post" action="">
        <input
          className=" form-control"
          value={nameSurename}
          onChange={(e) => setNameSurename(e.target.value)}
          type="text"
          placeholder="Name &amp; Surname"
        />

        <input
          type="text"
          className=" form-control"
          placeholder="Phone Number"
          value={phoneNumber}
          onChange={(e) => setPhonenumber(e.target.value)}
        />

        <input
          className=" form-control"
          type="text"
          placeholder="E-Mail Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <div>
          <div>
            <table className="table-responsive-sm text-nowrap">
              <tr>
                <td>
                  <label htmlFor="otp">Is the OTP signed?</label>
                </td>
                <td>
                  {" "}
                  <label>
                    <input
                      type="radio"
                      name="OTP"
                      value="Yes"
                      checked={otpSigned === "Yes"}
                      onChange={handleOTPChange}
                    />
                    Yes
                  </label>
                </td>
                <td>
                  <label>
                    <input
                      type="radio"
                      name="OTP"
                      value="No"
                      checked={otpSigned === "No"}
                      onChange={handleOTPChange}
                    />
                    No
                  </label>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div>
          <table>
            <tr>
              <td>Select type of advance :</td>
              <td>
                {" "}
                <label className="classes.label">
                  <input
                    type="radio"
                    name="advanceType"
                    value="Commission advance"
                    checked={advanceType === "Commission advance"}
                    onChange={handleAdvanceTypeChange}
                  />
                  Commission advance
                </label>
              </td>
              <td>
                <label className="classes.label">
                  <input
                    type="radio"
                    name="advanceType"
                    value="Sellers Advance"
                    checked={advanceType === "Sellers Advance"}
                    onChange={handleAdvanceTypeChange}
                  />
                  Seller’s advance
                </label>
              </td>
            </tr>
          </table>
        </div>
        <br />

        <p>
          For faster processing, include the following documents:
          <br />
          <ul>
            <li>OTP</li>

            <li>ID</li>
            <li>Proof of Address</li>
          </ul>
        </p>
        <p>
          <input
            type="file"
            className=" form-control"
            id="attachment"
            multiple
          />
          <br />
          <small>Hold CTRL in to select multiple files</small>
        </p>

        <button onClick={() => sendMail()} className=" btn btn-primary">
          Submit
        </button>
      </form>
    </>
  );
}

export default PropertyAIDA;
